<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">To Ginjer Buchanan, who believed in Sid from the beginning</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?bf73c458